const PREFIX = "/reducers/for_you/";
 
export const SET_FOR_YOU_QUESTIONS = `${PREFIX}SET_FOR_YOU_QUESTIONS`;
export const IS_LOADING = `${PREFIX}IS_LOADING`;
export const SET_FOR_YOU_ERROR = `${PREFIX}SET_FOR_YOU_ERROR`;
export const SET_FOR_YOU_CONTENT = `${PREFIX}SET_FOR_YOU_CONTENT`;
export const SET_ONBOARDING_COMPLETED = `${PREFIX}SET_ONBOARDING_COMPLETED`; 